import notify from './notify';

export default {
    notify
};